var t=Object.prototype.toString,r=function(r){return t.call(r)};export{r as _};
//# sourceMappingURL=_objectToString.js.map
